export default "__VITE_ASSET__K6QocV8v__"